import React from "react";
import { PRIOS, DEFAULT_FILTERS } from "../constants";
import PrioIcon from "./PrioIcon";
import "./FilterBar.css";

export default function FilterBar({ filters, onChange, employees, areas = [], showArea = true }) {
  const update = (key, value) => {
    onChange({ ...filters, [key]: value });
  };

  const toggleChip = (key, val) => {
    const current = filters[key] || [];
    const next = current.includes(val) ? current.filter((v) => v !== val) : [...current, val];
    update(key, next);
  };

  const isDefaultStatus = filters.status && filters.status.length === 1 && filters.status[0] === "open";
  const hasActiveFilters = (filters.status && filters.status.length > 0 && !isDefaultStatus) || (filters.person && filters.person.length > 0) || (filters.prio && filters.prio.length > 0) || (filters.area && filters.area.length > 0);

  // Departed staff stay in `employees` so their names still resolve elsewhere —
  // but there is nothing left to filter for, so they don't belong in the picker.
  const employeeList = (employees || []).filter((m) => !m.archived);

  const statusOptions = [
    { value: "open", label: "zu erledigen" },
    { value: "completed", label: "fertig" },
  ];

  const areaOptions = areas.map((k) => ({ value: k.key, label: k.label, color: k.border }));

  return (
    <div className="filter-bar">
      <div className="filter-header">
        <span className="filter-title">Filter</span>
        <button
          className="filter-reset"
          style={{ visibility: hasActiveFilters ? "visible" : "hidden" }}
          onClick={() => onChange(DEFAULT_FILTERS)}
        >
          Zurücksetzen
        </button>
      </div>

      <div className="filter-fields">
        <div className="filter-item">
          <label>Status</label>
          <div className="filter-chips">
            {statusOptions.map((s) => {
              const sel = (filters.status || []).includes(s.value);
              return (
                <button
                  key={s.value}
                  type="button"
                  className={`filter-chip ${sel ? "filter-chip-active" : ""}`}
                  onClick={() => toggleChip("status", s.value)}
                >
                  {s.label}
                </button>
              );
            })}
          </div>
        </div>

        <div className="filter-item">
          <label>Person</label>
          <div className="filter-chips">
            {employeeList.map((m) => {
              const sel = (filters.person || []).includes(String(m.id));
              return (
                <button
                  key={m.id}
                  type="button"
                  className={`filter-chip ${sel ? "filter-chip-active" : ""}`}
                  style={sel ? { background: m.color, borderColor: m.color } : {}}
                  onClick={() => toggleChip("person", String(m.id))}
                >
                  {m.abbreviation || m.name}
                </button>
              );
            })}
          </div>
        </div>

        <div className="filter-item">
          <label>Priorität</label>
          <div className="filter-chips">
            {PRIOS.map((p) => {
              const sel = (filters.prio || []).includes(p.value);
              return (
                <button
                  key={p.value}
                  type="button"
                  className={`filter-chip filter-chip-prio ${sel ? "filter-chip-active" : ""}`}
                  onClick={() => toggleChip("prio", p.value)}
                >
                  <PrioIcon prio={p.value} size={14} />
                  {p.label}
                </button>
              );
            })}
          </div>
        </div>

        {showArea && (
          <div className="filter-item">
            <label>Bereich</label>
            <div className="filter-chips">
              {areaOptions.map((a) => {
                const sel = (filters.area || []).includes(a.value);
                return (
                  <button
                    key={a.value}
                    type="button"
                    className={`filter-chip ${sel ? "filter-chip-active" : ""}`}
                    style={sel && a.color ? { background: a.color, borderColor: a.color } : (a.color ? { borderColor: a.color } : {})}
                    onClick={() => toggleChip("area", a.value)}
                  >
                    {a.label}
                  </button>
                );
              })}
            </div>
          </div>
        )}

      </div>
    </div>
  );
}
